
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conversations/mentions",
      function () {
        return require("private-next-pages/conversations/mentions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conversations/mentions"])
      });
    }
  